export default __webpack_public_path__ + "static/media/studentIcon.3208cd45.svg";